<script lang="ts">
    import ResultsHeader from '$saga/views/Search/ResultsHeader.svelte';

    export let searchResultTotal: number,
        searchDatalayer: string = '';
</script>

<ResultsHeader {searchResultTotal} {searchDatalayer} />
